module.exports = __webpack_public_path__ + "static/img/pic-01.464a094.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/m/pic-01.png
// module id = paCF
// module chunks = 1